import React, { useEffect, useState, useCallback } from 'react'
import { useRouteMatch } from 'react-router'
import style from './policy.module.sass'
import search from '../../../assets/images/searchicon.png';
import { ReactComponent as PlusIcon } from '../../../assets/svg/plus_btn.svg';
import { ReactComponent as MoreIcon } from '../../../assets/svg/more.svg';
import { ReactComponent as DeleteIcon } from "../../../assets/svg/delete.svg";
import { ReactComponent as EditIcon } from "../../../assets/svg/editIcon.svg";
import { ReactComponent as WarningIcon } from "../../../assets/svg/warningIcon.svg";
import { CreatePolicy } from './CreatePolicy'
import { ViewEditPolicy } from './ViewEditPolicy'
import { Http } from '../../../helpers/axois'
import { useToast } from '../../../helpers/commonFunction'
import { Modal } from '../../../helpers/commonUi'
import { maxBy } from 'lodash'
import { Tooltip } from 'antd'
import { useSelector } from 'react-redux'
import NoData from '../../apps/NoData'
import { logger } from '../../../constant/winston';

export default function Policy() {
    const { params: { orgId } }: any = useRouteMatch()

    const [mode, setMode] = useState('')

    const [policyList, setPolicyList] = useState<any[]>([])
    const [filteredPolicyList, setFilteredPolicyList] = useState<any[]>([])
    const [searchPolicy, setSearchPolicy] = useState('')
    const [selectedPolicy, setSelectedPolicy] = useState<any>({})

    const [popUpState, setPopUpState] = useState<any>({});
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [deletePolicyData, setDeletePolicyData] = useState<any>({});

    const orgPermissions: any = useSelector((state: any) => {
        return state.org.orgPermissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

    const canViewPolicy = orgPermissions.includes('policy.View')
    const canEditPolicy = orgPermissions.includes('policy.Edit')
    const canCreatePolicy = orgPermissions.includes('policy.Create')
    const canDeletePolicy = orgPermissions.includes('policy.Delete')

    const { ErrorToast, SuccessToast } = useToast()
    const getPolicy = useCallback(async (policyId: any = undefined, initial: boolean = false) => {
        try {
            const res: any = await Http.get(`/policy?orgId=${orgId}`).toPromise()
            if (res.length > 0) {
                if (policyId) {
                    setSelectedPolicy(res.find((item: any) => item.id_ === policyId))
                } else if (initial) {
                    setSelectedPolicy(res[0])
                } else {
                    setSelectedPolicy(maxBy(res, (item) => item.id_))
                }
                setMode('view')
            } else {
                setSelectedPolicy({})
                setMode('create')
            }
            setPolicyList(res)
        } catch (e) {
            logger.error(e)
        }
    }, [orgId])

    useEffect(() => {
        canViewPolicy && getPolicy(undefined, true)
    }, [canViewPolicy, getPolicy])

    useEffect(() => {
        const filteredPolicy = policyList.filter((policy: any) => policy.name.includes(searchPolicy))
        setFilteredPolicyList(filteredPolicy)
    }, [searchPolicy, policyList])

    const deletePolicy = (data: any) => {
        Http.delete(`/policy/${data.id_}?orgId=${orgId}`).subscribe(() => {
            if (selectedPolicy.id_ === data.id_) {
                getPolicy(undefined, true)
            } else {
                getPolicy(selectedPolicy.id_)
            }
            SuccessToast('Policy deleted successfully')
        }, () => {
            ErrorToast('Error deleting policy')
        })
    }

    const popUpContent = (data: any) => {
        return (
            <div className={style.popUpContainer}>
                <div
                    data-test-id="auth_edit_policies"
                    className={style.popUpItem}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (canEditPolicy) {
                            setMode('edit')
                            setSelectedPolicy(data)
                        } else {
                            ErrorToast('You are not authorized to edit policies')
                        }
                        setPopUpState({
                            [data.id_]: false,
                        });
                    }}
                >
                    <EditIcon height="14px" width="14px" />
                    <span data-test-id="edit" className={style.popUpItemText} style={{ color: "#292d32" }}>Edit</span>
                </div>
                <div
                    data-test-id="delete_policies"
                    className={style.popUpItem}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (canDeletePolicy) {
                            setDeletePolicyData(data)
                            setDeleteModalVisible(true)
                        } else {
                            ErrorToast('You are not authorized to delete policies')
                        }
                        setPopUpState({
                            [data.id_]: false,
                        });
                    }}
                >
                    <DeleteIcon height="14px" width="14px" />
                    <span className={style.popUpItemText} style={{ color: "#292d32" }}>Delete</span>
                </div>
            </div>
        );
    };

    const sourceList = (searchPolicy !== '') ? filteredPolicyList : policyList

    return (
        canViewPolicy
            ?
            <div className={style.policyContainer}>
                <div className={style.policyListContainer}>
                    {
                        canCreatePolicy && (
                            <div className={style.header}>
                                <h5 className={style.title}>CREATE POLICY</h5>
                                <PlusIcon data-test-id="plus_icon" width="24px" height="24px" onClick={() => {
                                    setMode('create')
                                    setSelectedPolicy({})
                                }} />
                            </div>
                        )
                    }
                    <div className={style.search} style={{ marginTop: canCreatePolicy ? undefined : '16px' }}>
                        <img src={search} alt="" />
                        <input data-test-id="search_policy" value={searchPolicy} type="search" onChange={(e) => setSearchPolicy(e.target.value)} placeholder="Search Policy..." />
                    </div>
                    <>
                        {
                            sourceList.map((policy: any) => {
                                return (
                                    <div data-test-id={`policy_${policy.name}`} key={policy.id_} style={{ backgroundColor: (selectedPolicy.id_ === policy.id_) ? '#0466C826' : '' }} className={style.itemContainer} onClick={() => {
                                        setMode('view')
                                        setSelectedPolicy(policy)
                                    }}>
                                        <div className={`${style.itemName} ${(selectedPolicy.id_ === policy.id_) && style.selectedItem}`}>{policy.name}</div>
                                        <Tooltip
                                            onVisibleChange={(visible) =>
                                                setPopUpState({
                                                    [policy.id_]: visible,
                                                })
                                            }
                                            visible={popUpState[policy.id_]}
                                            placement="right"
                                            overlayClassName="teamPopUp"
                                            title={() => popUpContent(policy)}
                                            trigger="click"
                                        >
                                            <div data-test-id={`${policy.name}_more_btn`} className={style.moreButtonContainer} onClick={(e) => {
                                                e.stopPropagation()
                                            }}>
                                                <MoreIcon height="10px" />
                                            </div>
                                        </Tooltip>
                                    </div>
                                )
                            })
                        }
                    </>
                </div>
                <div data-test-id="policy_view" className={style.policyView}>
                    {
                        mode === 'create'
                            ?
                            <CreatePolicy getPolicy={getPolicy} />
                            :
                            <ViewEditPolicy mode={mode} setMode={setMode} getPolicy={getPolicy} policy={selectedPolicy} />
                    }
                </div>
                <Modal
                    id="deletePolicy"
                    dataTestId="delete_policy"
                    unmountOnCancel={true}
                    visible={deleteModalVisible}
                    title="DELETE POLICY"
                    onCancel={() => {
                        setDeleteModalVisible(false);
                        setDeletePolicyData({});
                    }}
                    deleteOptions={{
                        type: "Policy",
                        validateString: deletePolicyData && deletePolicyData.name,
                    }}
                    footer={{
                        enable: true,
                        okText: "DELETE",
                        cancelText: "CANCEL",
                        onOk: () => {
                            deletePolicy(deletePolicyData);
                            setDeleteModalVisible(false);
                            setDeletePolicyData({});
                        },
                    }}
                />
            </div>
            :
            <NoData
                svg={WarningIcon}
                header='Not Authorized'
                content='Please request owner of this organization to provide access'
                noButton={true}
            />
    )
}
